<mat-expansion-panel [expanded]="filters.expanded.countries" (opened)="opened()" (closed)="closed()">
  <mat-expansion-panel-header>
    <mat-panel-title>By Country</mat-panel-title>
  </mat-expansion-panel-header>

  <mat-checkbox color="primary" *ngFor="let country of defaults.countries" (change)="toggle(country.record.name, $event.checked)" [checked]="filters.countries.indexOf(country.record.name)!==-1" [disabled]="country.count === 0"><i class="flag-icon flag-icon-{{ country.record.code.toLowerCase() }}"></i> {{ country.record.name }} ({{ country.count }})</mat-checkbox>

</mat-expansion-panel>
